export const GET_BOT_LIST_REQUESTED = "GET_BOT_LIST_REQUESTED";
export const GET_BOT_LIST_REQUESTED_SUCCESS = "GET_BOT_LIST_REQUESTED_SUCCESS";
export const GET_BOT_LIST_REQUESTED_FAILED = "GET_BOT_LIST_REQUESTED_FAILED";

export const GET_SUSPENDED_BOTS = "GET_SUSPENDED_BOTS";
export const GET_SUSPENDED_BOTS_SUCCESS = "GET_SUSPENDED_BOTS_SUCCESS";
export const GET_SUSPENDED_BOTS_FAILED = "GET_SUSPENDED_BOTS_FAILED";
